import React from 'react';

const NewBadge: React.FC = () => (
  <span className="new-badge">New</span>
);

export default NewBadge; 